

























import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "ChooseContentConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    showLiveButton: { type: Boolean, default: false },
    showProfileButton: { type: Boolean, default: false },
    showStoriesButton: { type: Boolean, default: false },
  },
});
